var WC_QTY={}, WC_STATE={items:[],total:0,retail:0,savings:0,units:0};
var WC_PRODS=[
  {id:"s7pro",   nm:"SuperBox S7 Pro",      pr:[190,185,180,175,160,155], mn:[1,2,5,10,20,50]},
  {id:"s7max",   nm:"SuperBox S7 Max",      pr:[200,195,190,180,170,165], mn:[1,2,5,10,20,50]},
  {id:"s7prime", nm:"S7 Prime / Ultra",     pr:[220,210,205,200,180],     mn:[1,2,6,10,20]},
  {id:"v6max",   nm:"Vsee V6 Max",          pr:[240,235,230,210],         mn:[1,2,5,20]},
  {id:"v6plus",  nm:"Vsee V6 Plus",         pr:[270,250,240,230],         mn:[1,2,6,20]},
  {id:"b2pro",   nm:"Vsee Black Box B2 Pro",pr:[200,195,185,180,170],     mn:[1,2,6,10,20]}
];

function wc_el(id){return document.getElementById(id);}
function wc_fmt(n){return"$"+Number(n).toLocaleString("en-US");}

function wc_price(id,q){
  var p=WC_PRODS.filter(function(x){return x.id===id;})[0];
  if(!p)return 0;
  var v=p.pr[0];
  for(var i=0;i<p.mn.length;i++){if(q>=p.mn[i])v=p.pr[i];}
  return v;
}
function wc_next(id,q){
  var p=WC_PRODS.filter(function(x){return x.id===id;})[0];
  if(!p)return null;
  for(var i=0;i<p.mn.length;i++){if(p.mn[i]>q)return{min:p.mn[i],pr:p.pr[i]};}
  return null;
}

function wc_setQty(id,val){
  var v=Math.max(0,Math.min(999,parseInt(val)||0));
  WC_QTY[id]=v;
  var inp=wc_el("wc-qty-"+id);
  if(inp&&String(inp.value)!==String(v||""))inp.value=v||"";
  wc_updateCard(id);
}

function wc_updateCard(id){
  var q=WC_QTY[id]||0, up=wc_price(id,Math.max(q,1));
  var card=wc_el("wc-card-"+id);
  if(!card)return;
  if(q>0)card.classList.add("on"); else card.classList.remove("on");
  var uEl=wc_el("wc-up-"+id); if(uEl)uEl.textContent=wc_fmt(up);
  var ltEl=wc_el("wc-lt-"+id), lvEl=wc_el("wc-lv-"+id);
  if(ltEl&&lvEl){ltEl.style.display=q>0?"block":"none";if(q>0)lvEl.textContent=wc_fmt(q*up);}
  var ldr=wc_el("wc-ladder-"+id);
  if(ldr){
    var p=WC_PRODS.filter(function(x){return x.id===id;})[0];
    var steps=ldr.querySelectorAll(".wc-step");
    for(var i=0;i<steps.length;i++){
      steps[i].classList.remove("wc-ac","wc-ps");
      if(q>0){if(p.pr[i]===up)steps[i].classList.add("wc-ac");else if(p.pr[i]>up)steps[i].classList.add("wc-ps");}
      else{if(i===0)steps[i].classList.add("wc-ac");}
    }
  }
  var ht=wc_el("wc-hint-"+id);
  if(ht){
    if(q>0){
      var nx=wc_next(id,q);
      if(nx){ht.style.display="block";ht.innerHTML="Add <strong>"+(nx.min-q)+" more</strong> &rarr; <strong>"+wc_fmt(nx.pr)+"/ea</strong> &middot; save <strong style='color:#4ade80'>"+wc_fmt((up-nx.pr)*q)+" more</strong>";}
      else{ht.style.display="block";ht.innerHTML="<span style='color:rgba(74,222,128,.8)'>&#10003; Best tier unlocked</span>";}
    }else{ht.style.display="none";}
  }
  wc_updateSummary();
}

function wc_updateSummary(){
  var items=[],total=0,retail=0,units=0;
  WC_PRODS.forEach(function(p){
    var q=WC_QTY[p.id]||0; if(!q)return;
    var up=wc_price(p.id,q), r1=p.pr[0];
    items.push({nm:p.nm,qty:q,up:up,lt:q*up,r1:q*r1});
    total+=q*up; retail+=q*r1; units+=q;
  });
  WC_STATE={items:items,total:total,retail:retail,savings:retail-total,units:units};
  var has=items.length>0;
  var em=wc_el("wc-empty"), hi=wc_el("wc-hasitems");
  if(em)em.style.display=has?"none":"block";
  if(hi)hi.style.display=has?"block":"none";
  if(has){
    if(wc_el("wc-stat-units"))wc_el("wc-stat-units").textContent=units;
    if(wc_el("wc-stat-total"))wc_el("wc-stat-total").textContent=wc_fmt(total);
    if(wc_el("wc-stat-save"))wc_el("wc-stat-save").textContent=WC_STATE.savings>0?wc_fmt(WC_STATE.savings):"—";
    if(wc_el("wc-grand"))wc_el("wc-grand").textContent=wc_fmt(total);
    var rows=wc_el("wc-lirows");
    if(rows){
      var html="";
      items.forEach(function(i){html+='<div class="wc-lirow"><span class="wc-ln">'+i.nm+'</span><span class="wc-lc">'+wc_fmt(i.up)+'</span><span class="wc-lc">'+i.qty+'</span><span class="wc-lr">'+wc_fmt(i.lt)+'</span></div>';});
      rows.innerHTML=html;
    }
    var rr=wc_el("wc-retail-row"), sr=wc_el("wc-save-row");
    if(WC_STATE.savings>0){
      if(rr){rr.style.display="flex"; wc_el("wc-retail-val").textContent=wc_fmt(retail);}
      if(sr){sr.style.display="flex"; wc_el("wc-save-val").textContent="- "+wc_fmt(WC_STATE.savings);}
    }else{if(rr)rr.style.display="none"; if(sr)sr.style.display="none";}
  }
  var bd=wc_el("wc-btn-dl"), bw=wc_el("wc-btn-wa");
  if(bd)bd.disabled=!has; if(bw)bw.disabled=!has;
}

window.wcPlus  = function(id){wc_setQty(id,(WC_QTY[id]||0)+1);};
window.wcMinus = function(id){wc_setQty(id,(WC_QTY[id]||0)-1);};
window.wcInput = function(id,val){wc_setQty(id,val);};
window.wcClear = function(){
  WC_PRODS.forEach(function(p){WC_QTY[p.id]=0;var i=wc_el("wc-qty-"+p.id);if(i)i.value="";wc_updateCard(p.id);});
};
window.wcContactProduct = function(name){
  var msg="Hi! I'm interested in wholesale pricing for the "+name+". Can you share your current wholesale rates and minimum order quantities?";
  window.open("https://wa.me/16616124759?text="+encodeURIComponent(msg));
};

window.wcDownload = function(){
  if(!WC_STATE.items.length)return;
  var s=WC_STATE;
  var date=new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"});
  var qno="QT-"+Date.now().toString().slice(-6);
  var co=wc_el("wcc-co")?wc_el("wcc-co").value:"";
  var cn=wc_el("wcc-cn")?wc_el("wcc-cn").value:"";
  var ce=wc_el("wcc-ce")?wc_el("wcc-ce").value:"";
  var cp=wc_el("wcc-cp")?wc_el("wcc-cp").value:"";
  var bill=[co,cn,ce,cp].filter(Boolean).join("<br>");
  var rows="";
  s.items.forEach(function(i){rows+="<tr><td>"+i.nm+"</td><td align='center'>"+wc_fmt(i.up)+"</td><td align='center'>"+i.qty+"</td><td align='right'>"+wc_fmt(i.lt)+"</td></tr>";});
  var savHtml="";
  if(s.savings>0){savHtml="<div class='tr'><span>List value</span><span>"+wc_fmt(s.retail)+"</span></div><div class='tr sv'><span>Savings</span><span>- "+wc_fmt(s.savings)+"</span></div>";}
  var billHtml=bill?"<div style='background:#f8fafc;border-radius:8px;padding:14px;margin-bottom:20px;font-size:14px;line-height:1.8'><b>Prepared for:</b><br>"+bill+"</div>":"";
  var html="<!DOCTYPE html><html><head><meta charset='UTF-8'><title>Wholesale Quote "+qno+"</title>";
  html+="<style>body{font-family:Arial,sans-serif;max-width:760px;margin:0 auto;padding:40px;color:#1e293b}";
  html+=".hd{display:flex;justify-content:space-between;border-bottom:3px solid #0ea5e9;padding-bottom:20px;margin-bottom:28px}";
  html+=".brand{font-size:20px;font-weight:900;color:#0ea5e9}.qi{text-align:right;font-size:13px;line-height:1.8}.qi b{font-size:17px;display:block}";
  html+="table{width:100%;border-collapse:collapse;margin:20px 0}th{background:#f1f5f9;padding:10px 12px;font-size:12px;font-weight:700;border-bottom:2px solid #e2e8f0;text-align:left}";
  html+="td{padding:10px 12px;border-bottom:1px solid #f1f5f9;font-size:14px}.tot{width:300px;margin-left:auto}";
  html+=".tr{display:flex;justify-content:space-between;padding:7px 0;font-size:14px;border-bottom:1px solid #f1f5f9}.sv{color:#16a34a;font-weight:600}";
  html+=".gd{font-size:17px;font-weight:800;border-top:2px solid #0ea5e9;border-bottom:none;padding-top:12px;margin-top:6px}";
  html+=".ft{margin-top:36px;padding-top:16px;border-top:1px solid #e2e8f0;font-size:12px;color:#94a3b8;line-height:1.8}@media print{button{display:none}}</style></head><body>";
  html+="<div class='hd'><div><div class='brand'>TV World &amp; E-Wholesale</div><div style='color:#64748b;font-size:13px'>tvworldewholesale.com</div></div>";
  html+="<div class='qi'><b>WHOLESALE QUOTE</b>Quote #: "+qno+"<br>Date: "+date+"<br>Valid 7 days</div></div>";
  html+=billHtml;
  html+="<table><thead><tr><th>Product</th><th align='center'>Unit Price</th><th align='center'>Qty</th><th align='right'>Line Total</th></tr></thead><tbody>"+rows+"</tbody></table>";
  html+="<div class='tot'>"+savHtml+"<div class='tr gd'><span>Total</span><span>"+wc_fmt(s.total)+"</span></div></div>";
  html+="<div class='ft'>Prices in USD. Valid 7 days. Subject to availability.<br>tvworldewholesale.com | WhatsApp: +1 (661) 612-4759 | junioresupplywholsale@gmail.com</div>";
  html+="<button onclick='window.print()' style='margin-top:20px;background:#0ea5e9;color:#fff;border:none;padding:12px 24px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer'>Print / Save as PDF</button>";
  html+="</body></html>";
  var blob=new Blob([html],{type:"text/html"}),url=URL.createObjectURL(blob),a=document.createElement("a");
  a.href=url;a.download="TVWorld-Wholesale-Quote.html";a.click();URL.revokeObjectURL(url);
};

window.wcEmail = function(){
  var s=WC_STATE;
  var co=wc_el("wcc-co")?wc_el("wcc-co").value:"";
  var cn=wc_el("wcc-cn")?wc_el("wcc-cn").value:"";
  var cp=wc_el("wcc-cp")?wc_el("wcc-cp").value:"";
  var lines=""; s.items.forEach(function(i){lines+="- "+i.nm+" x"+i.qty+" @ "+wc_fmt(i.up)+" = "+wc_fmt(i.lt)+"\n";});
  if(!lines)lines="(no items selected)";
  var body="Hello,\n\nI would like to place a wholesale order.\n\nCompany: "+(co||"-")+"\nContact: "+(cn||"-")+"\nPhone: "+(cp||"-")+"\n\nORDER:\n"+lines+"\nTotal Units: "+s.units+"\nTotal: "+wc_fmt(s.total)+"\n\nThank you!";
  window.location.href="mailto:junioresupplywholsale@gmail.com?subject=Wholesale Quote - "+s.units+" units&body="+encodeURIComponent(body);
};

window.wcWhatsApp = function(){
  if(!WC_STATE.items.length)return;
  var s=WC_STATE;
  var co=wc_el("wcc-co")?wc_el("wcc-co").value:"";
  var cn=wc_el("wcc-cn")?wc_el("wcc-cn").value:"";
  var lines=""; s.items.forEach(function(i){lines+="- "+i.nm+" x"+i.qty+" @ "+wc_fmt(i.up)+"\n";});
  var msg="Hi! Wholesale order:\n\n"+lines+"\nTotal: "+wc_fmt(s.total)+" ("+s.units+" units)";
  if(co)msg+="\nCompany: "+co; if(cn)msg+="\nContact: "+cn;
  window.open("https://wa.me/16616124759?text="+encodeURIComponent(msg));
};